export const notNullOrUndefined = (value: any) => {
  return value !== null && value !== undefined;
};



// WEBPACK FOOTER //
// ./src/app/utils/not-null-or-undefined.ts